module.exports = __webpack_public_path__ + "static/media/stone2_0.f39e398d.gif";